import { Routes } from '@angular/router';

import { VisaValueComponent } from './pages/visa-value/visa-value.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { FrequentlyAskedQuestionsComponent } from './pages/frequently-asked-questions/frequently-asked-questions.component';
import { PoliciesKvkkComponent } from './pages/policies-kvkk/policies-kvkk.component';
import { BlogComponent } from './pages/blog/blog.component';
import { HomeComponent } from './pages/home/home.component';
import { BlogDetailComponent } from './pages/blog/blog-detail/blog-detail.component';
import { PoliciesKvkkDetailComponent } from './pages/policies-kvkk/policies-kvkk-detail/policies-kvkk-detail.component';
import { PaymentResultComponent } from './pages/visa-value/payment/payment.result';
import { AppLayoutComponent } from './layouts/app-layout';
import { InterrogateComponent } from './pages/interrogate/interrogate.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'visa',
        component: VisaValueComponent,
      },
      { path: 'hakkimizda', component: AboutUsComponent },
      { path: 'iletisim', component: ContactUsComponent },
      { path: 'interrogate', component: InterrogateComponent },
      {
        path: 'sikca-sorulan-sorular',
        component: FrequentlyAskedQuestionsComponent,
      },
      {
        path: 'politikalar-ve-kvkk-dokumanlari',
        component: PoliciesKvkkComponent,
      },
      {
        path: 'politikalar-ve-kvkk-dokumanlari/:pageUrl',
        component: PoliciesKvkkDetailComponent,
      },
      { path: 'blog', component: BlogComponent },
      { path: 'blog/:pageUrl', component: BlogDetailComponent },
    ],
  },
  {
    path: 'payment-callback',
    component: PaymentResultComponent,
  },
];
